module.exports = "/_next/static/images/trezor_logo_suite_compact-5aac2c80199ceefb70637c9e3622c601.svg";